var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconTemplates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6C8.89543 6 8 6.89543 8 8V40C8 41.1046 8.89543 42 10 42H38C39.1046 42 40 41.1046 40 40V14.4142C40 13.8838 39.7893 13.3751 39.4142 13L33 6.58579C32.6249 6.21071 32.1162 6 31.5858 6H10ZM10 4C7.79086 4 6 5.79086 6 8V40C6 42.2091 7.79086 44 10 44H38C40.2091 44 42 42.2091 42 40V14.4142C42 13.3534 41.5786 12.3364 40.8284 11.5858L34.4142 5.17157C33.6636 4.42143 32.6466 4 31.5858 4H10Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14C14 13.4477 14.4477 13 15 13H25C25.5523 13 26 13.4477 26 14C26 14.5523 25.5523 15 25 15H15C14.4477 15 14 14.5523 14 14Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20C14 19.4477 14.4477 19 15 19H33C33.5523 19 34 19.4477 34 20C34 20.5523 33.5523 21 33 21H15C14.4477 21 14 20.5523 14 20Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 26C14 25.4477 14.4477 25 15 25H33C33.5523 25 34 25.4477 34 26C34 26.5523 33.5523 27 33 27H15C14.4477 27 14 26.5523 14 26Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 32C14 31.4477 14.4477 31 15 31H27C27.5523 31 28 31.4477 28 32C28 32.5523 27.5523 33 27 33H15C14.4477 33 14 32.5523 14 32Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconTemplates);
export default __webpack_public_path__ + "static/media/nav-icon-templates.6a21cc219ea8c09157b9913a69fd0fdf.svg";
export { ForwardRef as ReactComponent };